import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { AuthContext } from 'contexts/AuthContext';
import { toastWarning } from 'utils/toast';
import { useDialog } from 'components/Modals';
import Card from 'components/Card';
import Input from 'components/Input';
import Button from 'components/Button';
import TableContainer from 'components/TableContainer';
import styles from '../styles';

const Locais = ({
  loading,
  onSubmit,
  onDelete,
  equipamento = {},
  disableActions,
}) => {
  const { openDialog } = useDialog();
  const rotina = 'DocumentoEquipamentoLocal';
  const { user } = useContext(AuthContext);

  const Modal = ({ item }) => {
    const defaultValues = {
      id: item?.id,
      users_id: user?.id,
      documento_equipamento_id: equipamento?.id || null,
      localizacao: item?.localizacao || '',
    };
    const { control, handleSubmit } = useForm({ defaultValues });

    const onConfirm = (values) => {
      if (!Boolean(values?.localizacao)) {
        toastWarning('Localização obrigatória');
      } else {
        const Equipamentos = [
          {
            id: equipamento?.id,
            documento_id: equipamento?.documento_id,
            Locais: [values],
          },
        ];
        onSubmit({ Equipamentos });
      }
    };

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" component="div" align="center">
            Informações Gerais
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Input name="localizacao" control={control} label="Localização" />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(onConfirm)}
            loading={loading}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Card title="Locais" style={styles?.card}>
      <Grid container spacing={2}>
        {!disableActions && (
          <Grid item xs={12} textAlign="center">
            <Button
              variant="outlined"
              color="primary"
              onClick={() => openDialog(<Modal />, 'Adicionar Localização')}
            >
              Adicionar
            </Button>
          </Grid>
        )}
        {!!equipamento?.DocumentoEquipamentoLocals?.length && (
          <Grid item xs={12}>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Localização</TableCell>
                    {!disableActions && (
                      <TableCell align="center">Ações</TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {equipamento?.DocumentoEquipamentoLocals?.map((item) => (
                    <TableRow key={item?.id?.toString()}>
                      <TableCell>{item?.localizacao}</TableCell>
                      {!disableActions && (
                        <TableCell align="center">
                          <IconButton
                            size="small"
                            onClick={() =>
                              openDialog(
                                <Modal item={item} />,
                                'Editar Localização'
                              )
                            }
                          >
                            <Edit />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => onDelete({ rotina, id: item?.id })}
                          >
                            <Delete />
                          </IconButton>
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default Locais;
